module.exports = __webpack_public_path__ + "assets/img/5_1349_big.5ac5619a.jpg";